class Accordion extends Controller {
	constructor(...args){
		super(...args);
		this.items = []; //TODO: Учесть возможность динамического добавления окна!!
		this
			.initElements()
			.initEvents();
	}
	initElements(){
		this.items = Array.from(this.scope.querySelectorAll(this.options.selectors.blockItem));
		return this;
	}
	initEvents() {
		this.items.forEach((item)=>{
			item.querySelector(this.options.selectors.blockToggle).addEventListener(
				'click',
				()=> item.classList.toggle(this.options.stateClasses.blockActiveClass)
			);
		});
		return this;
	}
}